<template>
  <div id="app">
    
    <Header v-if="!$route.meta.showNav"></Header>
    <router-view></router-view>
  </div>
</template>

<script>
import storage from "./utils/storage";
import { getUserInfo } from "./api/api";
import Header from "./components/Header.vue";
export default {
  name: "App",
  components: {
    Header,
  },
  created() {
    this.$watch(() => {
      if (
        this.$route.name != null &&
        this.$route.name != "login" &&
        this.$route.name != "register" &&
        this.$route.name != "passwordFind" &&
        this.$route.name != "userDetail"
      ) {
        this.getUserInfo();
      }
    });
  },
  methods: {
    getUserInfo() {
      getUserInfo({ openid: this.$store.state.OPENID }).then((res) => {
        if (Object.keys(res).length > 0) {
          this.$store.commit("updateUserInfo", res);
        } else {
          storage.removeAll();
        }
      });
    },
  },
};
</script>

<style>
</style>
